/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Modal, NoteBox } from '../../../components';
import './index.css';
import EmailLoading from './EmailLoading.gif';
import emailSuccessIcon from './EmailSuccessIcon.svg';
import emailExpiredIcon from './EmailExpiredIcon.svg';

export type StatusType = 'warning' | 'error' | 'info' | 'success' | 'none';
const validationProperty = 'email';
const validationPropertyUp = 'Email';

export default ({
  status,
  resendLink,
  updateStatus,
  updatedValue,
  showModal,
  setShowModal,
}: any) => {
  const { t } = useTranslation();
  const ns = 'validation-modal';
  const dispatch = useDispatch();
  const refreshStatus = () => {
    updateStatus('info');
    resendLink();
    dispatch({
      type: 'OPEN_TOASTER',
      payload: {
        toasterTitle: t('validationModal.toasterTitle', { validationProperty }),
        toasterMessage: t('validationModal.toasterMessage', {
          validationProperty,
        }),
        toasterType: 'success',
        toasterVisible: true,
        toasterDismiss: null,
      },
    });
  };
  const titles: any = {
    info: t('validationModal.titleInfo', { validationProperty: 'email' }),
    warning: t('validationModal.titleWarning', { validationProperty: 'email' }),
    success: t('validationModal.titleSuccess', {
      validationPropertyUp: 'Email',
    }),
  };
  const descriptions: any = {
    info: t('validationModal.subTitleInfo', {
      validationProperty: 'email',
      updatedValue,
    }),
    warning: t('validationModal.subTitleWarning', {
      validationProperty: 'email',
    }),
    success: t('validationModal.merchant.subTitleSuccess'),
  };
  const badgeContentMap: Record<string, string | React.ReactNode> = {
    info: t('validationModal.badgeInfo', { validationProperty: 'email' }),
    warning: (
      <div>
        {t('validationModal.badgeWarning', { validationProperty })}
        <div style={{ textDecoration: 'underline' }} onClick={refreshStatus}>
          {t('validationModal.badgeWarningResend', { validationProperty })}
        </div>
      </div>
    ),
    success: t('validationModal.badgeSuccess', { validationPropertyUp }),
  };
  return (
    <Modal
      isOutsideClickClose
      className="store-action-modal"
      isVisible={showModal}
      onClose={() => {
        setShowModal(false);
      }}
    >
      <div className={`${ns}__header`}>
        <h2>{titles[status]}</h2>
        <p>{descriptions[status]}</p>
      </div>
      <div className={`${ns}__content`}>
        {status === 'info' && (
          <img src={EmailLoading} style={{ width: '95px' }} alt="loading..." />
        )}
        {status === 'success' && (
          <img src={emailSuccessIcon} style={{ width: '95px' }} alt="success" />
        )}
        {status === 'warning' && (
          <img src={emailExpiredIcon} style={{ width: '95px' }} alt="success" />
        )}
      </div>

      <div className={`${ns}__modal-footer`}>
        {status === 'success' ? (
          <div className={`${ns}__button-wrapper`}>
            <Button
              extraClass={`${ns}__button btn blue`}
              onClick={() => setShowModal(false)}
            >
              {t('validationModal.successButton')}
            </Button>
          </div>
        ) : (
          <NoteBox status={status}>{badgeContentMap[status]}</NoteBox>
        )}
      </div>
    </Modal>
  );
};
